const initialState = {
  pasajeros: null,
};

const formPassengers = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_FORMPASSENGERS':
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default formPassengers;
